import React, { useState, useEffect, lazy } from "react";
import { useParams } from "react-router-dom";
import SecondScreen from "../../SecondScreen";
import Navigation from "../../../components/navigation";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import axios from "axios";
import { isNoEditRoute, lazyRetry } from "../../../hooks/helpers";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import FileVcard from "./FileVcard";
import { useSelector } from "react-redux";
import { SuspenseLayout } from "../../../components/wrapper";

const NewVcard = lazy(() => lazyRetry(() => import("./NewVcard")));

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

function VCardPage() {
  const state = useSelector((state) => state);
  const { id } = useParams();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const [isNew, setIsNew] = useState(false);
  const [loadedData, setLoadedData] = useState(null);

  useEffect(() => {
    getContent("vcard");
  }, []);

  useEffect(() => {
    setIsNew(state.saveValue.valueVCard[10]);
  }, [state.saveValue.valueVCard]);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/vcard/get/${id}`)
        .then(({ data }) => {
          setLoadedData(data);
          setIsNew(
            !data[0]?.photo?.includes(".vcf") &&
              !data[0]?.photo?.includes(".vcard")
          );
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  return (
    <>
      <Navigation />
      <SecondScreen>
        {isNew ? (
          <SuspenseLayout>
            <NewVcard loadedData={loadedData} />
          </SuspenseLayout>
        ) : (
          <FileVcard loadedData={loadedData} setIsNew={setIsNew} />
        )}
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
}

export default VCardPage;
